<template>
  <Container :title="t('global.reset_password')">
    <form @submit.prevent="submit" class="form-container p-fluid">
      <p v-if="message">
        <InlineMessage severity="success">{{ message }}</InlineMessage>
      </p>

      <div class="form-container">
        <FormField v-model="email" :required="true" :title="t('global.login_email')" :placeholder="t('global.login_email')" icon-left="pi pi-envelope" :error="getError('email')" type="email" />

        <div class="button-container">
          <Button type="submit" :label="t('global.send_password')" :loading="busy" class="p-button-md" />
        </div>
      </div>
    </form>
  </Container>
</template>

<script setup>
import {ref} from "vue";
import {useForm} from "../../hooks/useForm";
import FormField from "../../components/FormField";
import {useUser} from "../../hooks/useUser";
import Container from "./Container";
import {useI18n} from 'vue-i18n';

const {t} = useI18n({useScope: 'global'})
const {forgotPassword} = useUser();

const email = ref('');
const message = ref('');

const {busy, submit, getError} = useForm(async () => {
  const data = await forgotPassword(email.value)

  if (data.message) {
    message.value = data.message;
  }
})

</script>

<style lang="scss" scoped>

</style>

